var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"layout-box-header-right-user-mask"},[_c('div',{staticClass:"layout-box-header-right-user-mask-box"},[_c('p',[_vm._v(_vm._s(_vm.title))]),_c('el-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary"},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$i18n.$t('确定')))])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }